import { Injectable } from '@angular/core'
import { TositeLaji } from '@lemon/core-firebase/model/tosite'
import { NumberDate } from '@lemon/core/model/common'

export type TositeHakuAikavali = 'viimeiset12kk' | 'viimeiset3kk' | 'viimeiset30pv' | 'tamaVuosi' | 'mukautettu' | 'kaikki'

export interface TositeHakuTila {
  hakuteksti: string
  aikavali: TositeHakuAikavali
  alkuPvm: NumberDate | null
  loppuPvm: NumberDate | null
  valitutMaksutavat: number[]
  valitutToimittajat: string[]
  valitutProjektit: string[]
  tositelaji: TositeLaji
  sivu: number
  sivunKoko: number
  paluureitti: string
}

@Injectable()
export class TositeHakuStateService {
  private _hakutila: TositeHakuTila | null = null

  tallennaHakutila(hakutila: TositeHakuTila) {
    this._hakutila = hakutila
  }

  onkoHakutilaTallennettu(paluureitti: string): boolean {
    return this._hakutila?.paluureitti === paluureitti
  }

  palautaHakutila(): TositeHakuTila | null {
    const hakutila = this._hakutila
    this._hakutila = null
    return hakutila
  }
}
